<div *ngIf="lang === 'ar'" dir="rtl" style="padding: 25px; background-color: #ffffff">
  <div class="header">
    <div class="logo">
      <div class="service-logo">
        <img
          src="./assets/images/newLogo.png"
        />
      </div>
      <div class="company-logo">
        <img
          src="./assets/images/digitalLogo.png"
          height="100px"
        />
      </div>
    </div>
    <div class="heading">
      <h1>سياسة الخصوصية في 5dma.vip</h1>
      <span>رقم الإصدار: 0.1</span> <br/>
      <span>التاريخ: 01-02-2022 </span>
    </div>
  </div>
  <div class="content-menu">
    <ul>
      <li>سياسة الخصوصية</li>
      <li>جمع المعلومات واستخدامها</li>
      <li>تسجيل البيانات</li>
      <li>مقدمي الخدمة</li>
      <li>حماية</li>
      <li>روابط لمواقع أخرى</li>
      <li>التغييرات على سياسة الخصوصية هذه</li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>1- سياسة الخصوصية :</h3>
      <li>
        1-1
        قامت DU-Apps ببناء تطبيق khdma كتطبيق مجاني.
      </li>
      <li>
        2-1
        يتم توفير هذه الخدمة بواسطة DU-Apps دون أي تكلفة وهي مخصصة للاستخدام كما هي.
      </li>
      <li>
        3-1
        تُستخدم هذه الصفحة لإعلام الزائرين بسياساتنا فيما يتعلق بجمع المعلومات الشخصية واستخدامها والكشف عنها
        معلومات إذا قرر أي شخص استخدام خدمتنا.
      </li>
      <li>
        4-1
        إذا اخترت استخدام خدمتنا، فإنك توافق على جمع واستخدام المعلومات المتعلقة بهذا
        سياسة.
      </li>
      <li>
        5-1
        يتم استخدام المعلومات الشخصية التي نجمعها لتوفير الخدمة وتحسينها.
      </li>
      <li>
        6-1
        لن نستخدم معلوماتك أو نشاركها مع أي شخص باستثناء ما هو موضح في سياسة الخصوصية هذه.
      </li>
      <li>
        7-1
        المصطلحات المستخدمة في سياسة الخصوصية هذه لها نفس المعاني كما في الشروط والأحكام الخاصة بنا، وهي
        يمكن الوصول
        في خدمة ما لم يتم تحديد خلاف ذلك في سياسة الخصوصية هذه.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>2- جمع المعلومات واستخدامها :</h3>
      <li>
        1-2
        للحصول على تجربة أفضل، أثناء استخدام خدمتنا، قد نطلب منك تزويدنا ببعض المعلومات شخصيًا
        معلومات يمكن تحديدها.
      </li>
      <li>
        2-2
        يستخدم التطبيق خدمات الجهات الخارجية التي قد تجمع المعلومات المستخدمة لتحديد هويتك.
      </li>
      <li>
        3-2
        رابط إلى سياسة الخصوصية لمقدمي خدمات الطرف الثالث الذين يستخدمهم التطبيق
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>3- بيانات السجل :</h3>
      <li>
        1-3
        نريد أن نعلمك أنه عندما تستخدم خدمتنا، في حالة حدوث خطأ في التطبيق، نقوم بجمع البيانات و
        المعلومات (من خلال منتجات الطرف الثالث) على هاتفك والتي تسمى بيانات السجل.
      </li>
      <li>
        2-3
        قد تتضمن بيانات السجل هذه معلومات
        مثل عنوان بروتوكول الإنترنت ("IP") الخاص بجهازك،
        اسم الجهاز، إصدار نظام التشغيل، تكوين
        التطبيق عند استخدام خدمتنا، ووقت وتاريخ استخدامك للخدمة، والإحصائيات الأخرى.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>4- مقدمو الخدمة :</h3>
      <li>
        1-4
        يجوز لنا توظيف شركات وأفراد من جهات خارجية للأسباب التالية:
        <ol>
          <li>لتسهيل خدمتنا.</li>
          <li>لأداء الخدمات المتعلقة بالخدمة.</li>
          <li>لمساعدتنا في تحليل كيفية استخدام خدمتنا.</li>
        </ol>
      </li>
      <li>
        2-4
        نريد إبلاغ مستخدمي هذه الخدمة بأن هذه الأطراف الثالثة يمكنها الوصول إلى معلوماتهم الشخصية.
      </li>
      <li>
        3-4
        والسبب هو أداء المهام الموكلة إليهم نيابة عنا.
      </li>
      <li>
        4-4
        ومع ذلك، فهم ملزمون بعدم الكشف عن المعلومات أو استخدامها لأي غرض آخر.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>5- الأمن :</h3>
      <li>
        1-5
        نحن نقدر ثقتك في تزويدنا بمعلوماتك الشخصية، وبالتالي نسعى جاهدين لاستخدامها تجاريًا
        الوسائل المقبولة لحمايتها.
      </li>
      <li>
        2-5
        لكن تذكر أنه لا توجد طريقة نقل عبر الإنترنت أو طريقة تخزين إلكترونية آمنة بنسبة 100%
        وموثوقة، ولا يمكننا ضمان أمنها المطلق.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>6- روابط لمواقع أخرى :</h3>
      <li>
        1-6
        قد تحتوي هذه الخدمة على روابط لمواقع أخرى.
      </li>
      <li>
        2-6
        إذا قمت بالنقر فوق رابط جهة خارجية، فسيتم توجيهك إلى هذا الموقع.
      </li>
      <li>
        3-6
        لاحظ أن هذه المواقع الخارجية لا يتم تشغيلها من قبلنا.
      </li>
      <li>
        4-6
        ولذلك، ننصحك بشدة بمراجعة سياسة الخصوصية الخاصة بهذه المواقع.
      </li>
      <li>
        5-6
        ليس لدينا أي سيطرة ولا نتحمل أي مسؤولية عن المحتوى أو سياسات الخصوصية أو الممارسات الخاصة بأي منها
        مواقع أو خدمات الطرف الثالث.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>7- التغييرات في سياسة الخصوصية هذه:</h3>
      <li>
        1-7
        قد نقوم بتحديث سياسة الخصوصية الخاصة بنا من وقت لآخر.
      </li>
      <li>
        2-7
        لذا ننصحك بمراجعة هذه الصفحة بشكل دوري لمعرفة أي تغييرات.
      </li>
      <li>
        3-7
        وسوف نقوم بإعلامك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة.
      </li>
      <li>
        4-7
        تسري هذه السياسة اعتبارًا من 2022-02-01
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>8- حذف حساب المستخدم :</h3>
      <li>
        1-8
        تطبيق الحضور المحمول الخاص بنا وتطبيق التجارة الإلكترونية يحترمان حقك في الخصوصية والتحكم في معلوماتك الشخصية.
        وبالتالي، نحن نوفر لك خيار حذف حساب المستخدم الخاص بك.
      </li>
      <li>
        2-8
        بالنسبة لتطبيق الحضور المحمول الخاص بنا، يتطلب حذف حساب المستخدم موافقة من مسؤول المستخدم في الشركة أو الموظف
        المسؤول. وذلك لضمان اتباع جميع الإجراءات والبروتوكولات
        اللازمة قبل حذف الحساب.
      </li>
      <li>
        3-8
        بالنسبة لتطبيق التجارة الإلكترونية الخاص بنا، يمكن للمستخدمين حذف حساب المستخدم الخاص بهم مباشرة دون الحاجة إلى
        موافقة من أي شخص. يمكن القيام بذلك من خلال إعدادات حساب المستخدم.
      </li>
      <li>
        4-8
        يرجى ملاحظة أنه بمجرد حذف حساب المستخدم، سيتم إزالة جميع البيانات والمعلومات المرتبطة بشكل دائم من أنظمتنا. هذا
        الإجراء لا رجعة فيه.
      </li>
      <li>
        5-8
        نحن ملتزمون بحماية خصوصيتك وضمان أن لديك التحكم في معلوماتك الشخصية. إذا كان لديك أي أسئلة أو مخاوف بشأن حذف
        حساب المستخدم الخاص بك، فلا تتردد في الاتصال بنا.
      </li>
      <li>
        6-8
        وهنا بيان إضافي يشرح كيف يمكن للمستخدم تقديم طلب لحذف حسابهم من التطبيق المحمول:

        في تطبيق الحضور المحمول الخاص بنا، يمكن للمستخدمين تقديم طلب لحذف حسابهم مباشرة من التطبيق المحمول. يمكن القيام بذلك من خلال التنقل إلى صفحة "المزيد" وتحديد خيار "حذف الحساب". بمجرد تقديم الطلب، سيتم إرساله إلى مسؤول المستخدم في الشركة أو الموظف المسؤول للموافقة. بمجرد الموافقة، سيتم حذف حساب المستخدم وإزالة جميع البيانات والمعلومات المرتبطة بشكل دائم من أنظمتنا.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>اتصل بنا :</h3>
      <li>
        إذا كان لديك أي أسئلة أو اقتراحات حول سياسة الخصوصية الخاصة بنا، فلا تتردد في الاتصال بنا على
        info&#64;du-apps.com.
      </li>
    </ul>
  </div>
  <div class="company-footer-logo">
    <img height="200px" src="./assets/images/digitalLogo.png"/>
  </div>
</div>
<div *ngIf="lang === 'en'" dir="ltr" style="padding: 25px; background-color: #ffffff">
  <div class="header">
    <div class="logo">
      <div class="service-logo">
        <img
          src="./assets/images/newLogo.png"
        />
      </div>
      <div class="company-logo">
        <img
          src="./assets/images/digitalLogo.png"
          height="100px"
        />
      </div>
    </div>

    <div class="heading">
      <h1>Privacy Policy in 5dma.vip</h1>
      <span>Version number: 0.1</span> <br/>
      <span>Date: 01-02-2022 </span>
    </div>
  </div>
  <div class="content-menu">
    <ul>
      <li>Privacy Policy</li>
      <li>Information Collection and Use</li>
      <li>Log Data</li>
      <li>Service Providers</li>
      <li>Security</li>
      <li>Links to Other Sites</li>
      <li>Changes to This Privacy Policy</li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>1- Privacy Policy :</h3>
      <li>
        1-1
        DU-Apps built the khdma app as a Free app.
      </li>
      <li>
        2-1
        This SERVICE is provided by DU-Apps at no cost and is intended for use as is.
      </li>
      <li>
        3-1
        This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal
        Information if anyone decided to use our Service.
      </li>
      <li>
        4-1
        If you choose to use our Service, then you agree to the collection and use of information in relation to this
        policy.
      </li>
      <li>
        5-1
        The Personal Information that we collect is used for providing and improving the Service.
      </li>
      <li>
        6-1
        We will not use or share your information with anyone except as described in this Privacy Policy.
      </li>
      <li>
        7-1
        The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which are
        accessible
        at khdma unless otherwise defined in this Privacy Policy.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>2- Information Collection and Use :</h3>
      <li>
        1-2
        For a better experience, while using our Service, we may require you to provide us with certain personally
        identifiable information.
      </li>
      <li>
        2-2
        The app does use third-party services that may collect information used to identify you.
      </li>
      <li>
        3-2
        Link to the privacy policy of third-party service providers used by the app
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>3- Log Data :</h3>
      <li>
        1-3
        We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and
        information (through third-party products) on your phone called Log Data.
      </li>
      <li>
        2-3
        This Log Data may include information
        such as your device Internet Protocol (“IP”) address,
        device name, operating system version, the configuration of
        the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>4- Service Providers :</h3>
      <li>
        1-4
        We may employ third-party companies and individuals due to the following reasons:
        <ol>
          <li>To facilitate our Service.</li>
          <li>To facilitate our Service.</li>
          <li>To perform Service-related services.</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ol>
      </li>
      <li>
        2-4
        We want to inform users of this Service that these third parties have access to their Personal Information.
      </li>
      <li>
        3-4
        The reason is to perform the tasks assigned to them on our behalf.
      </li>
      <li>
        4-4
        However, they are obligated not to disclose or use the information for any other purpose.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>5- Security :</h3>
      <li>
        1-5
        We value your trust in providing us your Personal Information, thus we are striving to use commercially
        acceptable means of protecting it.
      </li>
      <li>
        2-5
        But remember that no method of transmission over the internet, or method of electronic storage is 100% secure
        and reliable, and we cannot guarantee its absolute security.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>6- Links to Other Sites :</h3>
      <li>
        1-6
        This Service may contain links to other sites.
      </li>
      <li>
        2-6
        If you click on a third-party link, you will be directed to that site.
      </li>
      <li>
        3-6
        Note that these external sites are not operated by us.
      </li>
      <li>
        4-6
        Therefore, we strongly advise you to review the Privacy Policy of these websites.
      </li>
      <li>
        5-6
        We have no control over and assume no responsibility for the content, privacy policies, or practices of any
        third-party sites or services.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>7- Changes to This Privacy Policy :</h3>
      <li>
        1-7
        We may update our Privacy Policy from time to time.
      </li>
      <li>
        2-7
        Thus, you are advised to review this page periodically for any changes.
      </li>
      <li>
        3-7
        We will notify you of any changes by posting the new Privacy Policy on this page.
      </li>
      <li>
        4-7
        This policy is effective as of 2022-02-01
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>8- Deletion of User Account :</h3>
      <li>
        1-8
        Our attendance solution mobile application and e-commerce application respect your right to privacy and the control of your personal information. As such, we provide you with the option to delete your user account.
      </li>
      <li>
        2-8
        For our attendance solution mobile application, the deletion of a user account requires approval from the company user admin or responsible employee. This is to ensure that all necessary procedures and protocols are followed before the deletion of the account.
      </li>
      <li>
        3-8
        For our e-commerce application, users have the ability to delete their user account directly without the need for approval from anyone. This can be done through the user account settings.
      </li>
      <li>
        4-8
        Please note that once a user account is deleted, all associated data and information will be permanently removed from our systems. This action is irreversible.
      </li>
      <li>
        5-8
        We are committed to protecting your privacy and ensuring that you have control over your personal information. If you have any questions or concerns about the deletion of your user account, please do not hesitate to contact us.
      </li>
      <li>
        6-8
        In our attendance solution mobile application, users can submit a request to delete their account directly from the mobile application. This can be done by navigating to the "More" page and selecting the "Delete Account" option. Once the request is submitted, it will be sent to the company user admin or responsible employee for approval. Once approved, the user account will be deleted and all associated data and information will be permanently removed from our systems.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>Contact Us :</h3>
      <li>
        If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at
        info&#64;du-apps.com.
      </li>
    </ul>
  </div>
  <div class="company-footer-logo">
    <img height="200px" src="./assets/images/digitalLogo.png"/>
  </div>
</div>

